<template>
  <v-container>
    <LimitedFileInput v-if="limitedFiles" ref="input" :label="label" :files-count="filesCount" />
    <MultipleFileInput v-else ref="input" @input="$emit('attachment-change', $event)" />
  </v-container>
</template>

<script>
export default {
  name: 'FileInput',
  props: {
    label: {
      type: String,
      default: () => '',
    },
    filesCount: {
      type: Number,
      default: () => 3,
    },
  },
  computed: {
    fileUpload() {
      return this.$refs.input.$refs.fileUpload
    },
    limitedFiles() {
      return this.filesCount > 0
    },
  },
  methods: {
    cleanup() {
      this.$refs.input?.cleanup()
    },
  },
}
</script>
